module.exports = __webpack_public_path__ + "assets/img/icon_arrow-gray.19b59e7e.svg";